"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assistantWeeklyTemplateApiResponseSchema = exports.assistantTemplateEntrySchema = void 0;
const zod_1 = require("zod");
const enums_1 = require("./enums");
exports.assistantTemplateEntrySchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    weekday: zod_1.z.number().int().min(1).max(7),
    slotTypeId: zod_1.z.string().uuid(),
});
exports.assistantWeeklyTemplateApiResponseSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    officeId: zod_1.z.string().uuid(),
    week: enums_1.templateWeekSchema,
    entries: zod_1.z.array(exports.assistantTemplateEntrySchema),
});
